/* eslint-disable react/require-default-props */

import React from 'react';
import config from '../../../../../config';
import StepList from '../../../components/StepList/StepList';

import './PlanContainer.scss';

interface IPlanContainer {
  planDayIndex: number;
  changePlanDayIndex: (newPlanDayIndex: number) => void;
  show: boolean;
  alternativesStepId?: number;
  setAlternativesStepId: (stepId?: number) => void;

  showExplorePlaces: () => void;
  showLocalExperiences: () => void;
}

const PlanContainer: React.FC<IPlanContainer> = ({ planDayIndex, changePlanDayIndex, show, alternativesStepId, setAlternativesStepId, showExplorePlaces, showLocalExperiences }) => {
  const planContainerClasses = ['planContainer'];
  if (config.HIDE_OVERVIEW) planContainerClasses.push('container-height');
  else planContainerClasses.push('container-height-tab');
  if (show) planContainerClasses.push('planContainerOpen');
  else planContainerClasses.push('planContainerClose');

  return (
    <div className={planContainerClasses.join(' ')}>
      <StepList
        alternativesStepId={alternativesStepId}
        setAlternativesStepId={setAlternativesStepId}
        planDayIndex={planDayIndex}
        changePlanDayIndex={changePlanDayIndex}
        showExplorePlaces={showExplorePlaces}
        showLocalExperiences={showLocalExperiences}
      />
    </div>
  );
};

export default PlanContainer;
